<template>
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.1699 17.8973C6.87392 16.0737 3.41856 12.7107 1.47651 8.48097L1.47534 8.47843L0.920841 7.25871C0.181741 5.63296 0.691669 3.71155 2.13965 2.66624L3.91294 1.38608C4.66706 0.841674 5.71529 0.982279 6.29929 1.70617L8.09433 3.93122C8.71889 4.70539 8.57342 5.84378 7.77426 6.43602L7.10476 6.93218C8.23567 9.12657 10.0281 10.919 12.2224 12.0499L12.7186 11.3804C13.3108 10.5812 14.4492 10.4357 15.2234 11.0603L17.4482 12.8551C18.1723 13.4393 18.3127 14.4879 17.7678 15.242L16.4935 17.0058C15.4541 18.4442 13.5487 18.9572 11.9277 18.2349L11.1699 17.8973Z" stroke="#130F26" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name: "PhoneIcon"
    }
</script>